// extracted by mini-css-extract-plugin
export default {"wrapper":"tree_wrapper__SXJIo","svg":"tree_svg__HZ3+3","menu":"tree_menu__Gyx8X"};